<script>
  import { _ as t } from "svelte-i18n";
  import { query } from "svelte-apollo";
  import { Button, Title } from "t2c-components";

  import { fromDbToDisplay, fromDisplayToDb } from "utils.js";
  import { info } from "notifications/notify.js";

  import { client } from "apollo.js";
  import {
    ME_CLIENT_PERSONAL_DATA_QUERY,
    CLIENT_UPDATE_DATA_MUTATION,
  } from "queries.js";

  import PersonForm from "./PersonForm.svelte";
  import CompanyForm from "./CompanyForm.svelte";
  import Switcher from "./Switcher.svelte";

  const personalData = query(client, {
    query: ME_CLIENT_PERSONAL_DATA_QUERY,
  });

  let data = {
    firstName: "",
    lastName: "",
    birthDate: "",
    birthPlace: "",
    birthState: "",
    birthCountry: "",
    fiscalCode: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",

    officialName: "",
    companyFiscalCode: "",
    companyTvaNumber: "",
    companyZipCode: "",
    companyAddress: "",
    companyCity: "",
    companyCountry: "",
    pecEmail: "",
  };

  let selected;

  personalData
    .result()
    .then((result) => {
      data = fromDbToDisplay(result.data.meClient);
      selected = data.type;
    })
    .catch((err) => console.log("promise err:", err));

  let inFlight = false;
  let errors = {};
  let message;

  const handleSwitch = (e) => {
    selected = e.target.value;
  };

  const submit = async (e) => {
    e.preventDefault();
    inFlight = true;
    try {
      const inputData = fromDisplayToDb(data);
      const result = await client.mutate({
        mutation: CLIENT_UPDATE_DATA_MUTATION,
        variables: {
          params: inputData,
        },
      });
      inFlight = false;
      data = fromDbToDisplay(result.data.updateClientData);
      info($t("successPersonal"));
    } catch (err) {
      console.error(err);
      if (err.graphQLErrors && err.networkError) {
        const { graphQLErrors, networkError } = err;
        const messages = graphQLErrors.map(({ message }) => message);
        message = messages.join(" ");

        // assign error messages to errors object
        console.log(graphQLErrors);
        graphQLErrors
          .filter((e) => e.hasOwnProperty("key"))
          .map(({ key, message }) => {
            errors[key] = message.join(" ");
          });

        console.log(errors);
      }
      message = err;
      inFlight = false;
    }
  };
</script>

<div class="container">
  {#await $personalData}
    <section class="wrapper">
      <div class="box">
        <Title title={$t("personalData")} />
        <div style="height: 35vh">
          <p>Loading...</p>
        </div>
      </div>
    </section>
  {:then result}
    <section class="wrapper">
      <div class="box">
        <Title title={$t("personalData")} />
      </div>
      <div class="box">
        <div class="form">
          <Switcher {data} on:change={handleSwitch} />
          {#if selected === "person"}
            <PersonForm {data} {errors} />
          {:else}
            <CompanyForm {data} {errors} />
          {/if}
          <div class="form-action">
            <Button text={$t("data.action")} on:click={submit} />
          </div>
          {#if message}
            <div class="message">
              <p>{message}</p>
            </div>
          {/if}
        </div>
      </div>
    </section>
  {:catch error}
    <p>ERROR: {error}</p>
  {/await}
</div>

<style>
  .container {
    padding-bottom: 48px;
  }

  .box {
    padding-top: 24px;
    border-top: 1px solid var(--blue-color);
  }
  .box:first-child {
    border-top: 0;
  }

  .box p {
    margin: 48px 0 0;
    font-size: 14px;
  }

  .form {
    margin: 48px auto;
    max-width: 850px;
  }

  .form-action {
    text-align: left;
    padding-top: 24px;
  }

  .message p {
    color: var(--marine-color);
  }
</style>
